
interface Props {
    children: any;
    isOpen: boolean;
    setIsOpen: any;
    title?: React.ReactNode;
    width?: string;
    onClose?: () => void;
}

const Drawer: React.FC<Props> = ({
    children,
    isOpen,
    setIsOpen,
    title,
    width,
    onClose,
}) => {
    const handleClose = onClose ?? (() => setIsOpen(false));

    return (
        <>
            <div
                className={`${
                    isOpen ? 'visible' : 'invisible'
                } fixed bottom-0 left-0 right-0 top-0 z-999 bg-black opacity-50`}
            ></div>
            <div
                className={`${isOpen ? '-translate-x-0' : 'translate-x-full'} ${
                    width ? width : 'w-1/3'
                } fixed right-0 top-0 z-999 h-full flex flex-col bg-white shadow-default duration-300 ease-linear`}
            >
                <div className='sticky top-0 z-10 flex items-center justify-between bg-white px-[24px] pt-[24px] pb-[16px] border-b border-gray-200'>
                    {title ? (
                        <h1 className='text-[22px]/[28px] font-bold'>
                            {title}
                        </h1>
                    ) : <div />}
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        fill='currentColor'
                        className='cursor-pointer flex-shrink-0'
                        onClick={handleClose}
                        viewBox='0 0 16 16'
                    >
                        <path d='M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z' />
                    </svg>
                </div>
                <div className='flex-1 overflow-y-auto p-[24px]'>
                    {isOpen && children}
                </div>
            </div>
        </>
    );
};

export default Drawer;
